export default {
  ACCEPTED_FORMATS: '(Accepted formats: JPEG, PNG, JPG)',
  ACCOUNTING_CODE: 'Accounting code',
  ACTIONS: 'Actions',
  ACTIVE: 'Active',
  ACTIVE_ORDER_FILTER: 'Active Order Filter',
  ACTIVE_ORDERS: 'Active Orders',

  ADD: 'Add',
  ADD_CATEGORY: 'Add Category',
  ADD_INGREDIENT: 'Add Ingredient',
  ADD_NEW_TAX: 'Add New Tax',
  ADD_PRODUCT: 'Add Product',
  ADD_STORE: 'Add Customer',
  ADD_SUB_CATEGORY: 'Add Subcategory',
  ADD_SUPPLIER: 'Add Supplier',
  ADD_TAX: 'Add Tax',
  ADDING_NEW_CATEGORY_DETAILS: 'Adding new Category Details...',
  ADDING_NEW_INGREDIENT_DETAILS: 'Adding new Ingredient details...',
  ADDING_NEW_NOTE: 'Adding new Note...',
  ADDING_NEW_PRODUCTS_DETAILS: 'Adding new Product details...',
  ADDING_NEW_SUB_CATEGORY_DETAILS: 'Adding new Subcategory Details...',
  ADDRESS: 'Address',

  APPLY: 'Apply',
  ASSIGN: 'Assign',
  ASSIGN_PRODUCT: 'Assign Product...',
  ASSIGNED_PRODUCTS: 'Assigned Products',
  ASSIGNMENT: 'Assignment',
  AUTHENTICATING: 'Authenticating...',

  BACK_ORDER: 'Backorder',
  BACKORDER: 'Backorder',
  BAKEASY_SUPPLIER_PORTAL: 'Order-EZ Supplier Portal',
  BILL_DATE: 'Bill Date',
  BILL_ID: 'Bill ID',
  BILL_TO: 'Bill To',
  BILL_TO_NAME: 'Bill To Name',
  BILLING_DETAILS: 'Billing Details',

  CANCEL: 'Cancel',
  CANCEL_ORDER: 'Cancel order',
  CANCELLING_ORDER_STATUS: 'Cancelling Order Status',
  CATEGORIES: 'Categories',
  CATEGORY: 'Category',
  CATEGORY_NAME: 'Category Name',

  CHAIN_STORE_NAME: 'Chain Store Name',
  CHAIN_STORE_PARENT: 'Chain Store/Parent Company',
  CHANGE_PASSWORD: 'Change Password',
  CHECK: 'Check',
  CITY: 'City',
  CLEAR: 'Clear',
  CLOSE: 'Close',

  COMPANY_ADDRESS: 'Company Address',
  COMPANY_NAME: 'Company Name',
  COMPOSE: 'Compose',

  CONFIRM: 'Confirm',
  CONFIRM_INVOICE_DETAILS: 'Confirm Invoice Details',
  CONFIRM_QUANTITY: 'Confirm Quantity',
  CONFIRM_PASSWORD: 'Confirm Password',
  CONFIRM_PRODUCTION: 'Confirm Production',
  CONSOLIDATED_RECIPE_BUILDER_BY_MULTIPLE_PRODUCT:
    'Consolidated recipe builder by Multiple Product',

  CONTACT: 'Contact',
  CONTACT_ACCOUNTING: 'Contact-Accounting',
  CONTACT_BAKEASY: 'Contact Bakeasy to add the Recipe Builder option',
  CONTACT_STORE: 'Contact Customer',
  CONTACT_SUPPORT: 'Please contact System Technical Support',
  CONTACT1: 'Contact 1',
  CONTACT2: 'Contact 2',
  CONTENT: 'Content',
  COST_PRICE: 'Cost Price',
  COUNTRY: 'Country',
  CREATE: 'Create',
  CREATE_ORDER: 'Create Order',
  CREATE_SHIPPING_MEMO_ONLY: 'Create Shipping Memo Only',
  CREATE_SHIPPING_MEMO_INVOICE: 'Create Shipping Memo and Invoice',
  CREATED_DATE: 'Created Date',
  CREATING_INVOICE: 'Creating Invoice',
  CURRENT_PASSWORD: 'Current Password',
  CUSTOMER: 'Customer',

  DATE: 'Date',
  DATE_CREATED: 'Date Created',
  DATE_MM_DD_YYYY: 'Date',
  DATE_ORDERED: 'Date Ordered',
  DATE_REGISTERED: 'Date registered (MM/DD/YYYY)',
  DATE_REGISTERED_AS_STORE: 'Date registered as a Customer',
  DATE_TO_BE_DELIVERED: 'Date to be Delivered',

  DEACTIVATE: 'Deactivate',
  DEACTIVATE_CATEGORY: 'Deactivate Category',
  DEACTIVATE_CATEGORY_MESSAGE:
    'Are you sure you want to deactivate this Category?',
  DEACTIVATE_SUB_CATEGORY: 'Deactivate Subcategory',
  DEACTIVATE_SUB_CATEGORY_MESSAGE:
    'Are you sure you want to deactivate this Subcategory?',
  DEACTIVATE_STORE: 'Deactivate Customer',
  DEACTIVATE_STORE_MESSAGE:
    'Are you sure you want to deactivate this customer?',
  DEACTIVATING_PRODUCT: 'Deactivating Product...',
  DEACTIVATING_STORE: 'Deactivating Customer...',

  DELETE: 'Delete',
  DELETE_MESSAGE_CONFIRMATION: 'Are you sure you want to delete this message?',
  DELETE_MESSAGE: 'Delete Messages',
  DELETING_MESSAGE: 'Deleting Message...',
  DELIVERED_DATE: 'Delivered Date',
  DELIVERED_ORDER: 'Delivered Order',
  DELIVERIES: 'Deliveries',
  DELIVERY_DATE: 'Delivery Date',
  DELIVERY_ID: 'Delivery ID',
  DESCRIPTION: 'Description',

  DIFFERENT_LEGAL_NAME: 'Different Legal Name',
  DISCOUNT_PER: 'Discount % of Retail Price',

  DOWNLOAD_FAILS: 'Download Fails',
  DOWNLOAD_SUCCESS: 'Download Success',
  DOWNLOADING_CATEGORIES: 'Downloading Categories...',
  DOWNLOADING_NEW_ORDER_SUMMARY: 'Downloading New Order Summary...',
  DOWNLOADING_ORDERS: 'Downloading Orders...',
  DOWNLOADING_PRODUCT: 'Downloading Product...',
  DOWNLOADING_PRODUCT_DETAILS: 'Downloading Product details...',
  DOWNLOADING_STORE: 'Downloading Customer...',
  DOWNLOADING_STORE_DETAILS: 'Downloading Customer Details...',
  DOWNLOADING_STORE_PRODUCTS: 'Downloading Customer Products...',
  DOWNLOADING_SUBCATEGORIES: 'Downloading Subcategories...',
  DUE_DATE: 'Due From-To Dates',
  DUPLICATE: 'Duplicate',
  DOES_NOT_ACCEPT_BACKORDERS: 'This store does not accept backorders',

  EDIT: 'Edit',
  EDIT_CATEGORY: 'Edit Category',
  EDIT_ORDER: 'Edit Order',

  EDIT_PRODUCT: 'Edit Product',
  EDIT_STORE: 'Edit Customer',
  EDIT_SUB_CATEGORY: 'Edit Subcategory',
  EMAIL: 'Email',
  EMAIL_ID: 'Email ID',

  ENTER: 'Enter ',
  ENTER_ACCOUNTING_CODE: 'Enter Accounting code',
  ENTER_CHAIN_STORE_NAME: 'Enter Chain Store Name',
  ENTER_EMAIL_ID: 'Enter Email ID',
  ENTER_FIRST_NAME: 'Enter First Name',
  ENTER_LAST_NAME: 'Enter Last Name',
  ENTER_LEGAL_NAME: 'Enter Legal Name',
  ENTER_MESSAGE: 'Enter Message',
  ENTER_MOBILE_NUMBER: 'Enter Mobile Number',

  ENTER_PARENT_ADDRESS: 'Enter Parent Address',
  ENTER_PARENT_CITY: 'Enter Parent City',
  ENTER_PARENT_COUNTRY: 'Enter Parent Country',
  ENTER_PARENT_POSTAL_CODE: 'Enter Parent Zip/Postal Code',
  ENTER_PARENT_STATE: 'Enter Parent State/Province',

  ENTER_PASSWORD: 'Enter Password',
  ENTER_PRODUCT_NAME: 'Enter Product Name',

  ENTER_SHIPPING_RATE: 'Enter Shipping Rate',
  ENTER_STORE_ADDRESS: 'Enter Customer Address',
  ENTER_STORE_CITY: 'Enter Customer City',
  ENTER_STORE_COUNTRY: 'Enter Customer Country',
  ENTER_STORE_DISCOUNT: 'Enter Customer Discount',
  ENTER_STORE_NAME: 'Enter Customer Name',
  ENTER_STORE_POSTAL_CODE: 'Enter Customer Zip/Postal Code',
  ENTER_STORE_STATE: 'Enter Customer State/Province',

  ENTER_USER_NAME: 'Enter User Name',
  ENTER_WORK_PHONE_NUMBER: 'Enter Work Phone Number',
  ENTER_YOUR_PASSWORD: 'Enter your Password',
  ENTER_YOUR_USERNAME: 'Enter your Username',

  ESTIMATED_SHIPPING_CHARGES: 'Estimated Shipping Charges',
  ESTIMATED_TAXES_1: 'Estimated Taxes 1',
  ESTIMATED_TAXES_2: 'Estimated Taxes 2',
  EXPECTED_DATE: 'Expected Date',
  EXPORT: 'Export',

  FETCHING_ACTIVE_ORDERS: 'Fetching Active Orders...',
  FETCHING_CATEGORIES: 'Fetching Categories...',
  FETCHING_CATEGORIES_DETAILS: 'Fetching Categories Details...',
  FETCHING_COUNTRIES: 'Fetching Countries',
  FETCHING_INGREDIENTS: 'Fetching Ingredients...',
  FETCHING_INVOICES: 'Fetching Invoices...',
  FETCHING_NAMES: 'Fetching Names...',
  FETCHING_MESSAGE_STATUS: 'Fetching Message Status...',
  FETCHING_MESSAGES: 'Fetching Messages...',
  FETCHING_PRODUCT_NAMES: 'Fetching Product Names...',
  FETCHING_PRODUCTS: 'Fetching Products...',
  FETCHING_PRODUCTS_DETAILS: 'Fetching Products Details...',
  FETCHING_ORDER_DETAILS: 'Fetching Order details...',
  FETCHING_ORDERPROCESSING: 'Fetching OrderProcessing...',
  FETCHING_ORDERPROCESSING_DETAILS: 'Fetching OrderProcessing details...',
  FETCHING_ORDERS: 'Fetching Orders...',
  FETCHING_RECIPE: 'Fetching Recipe...',
  FETCHING_RECIPE_DETAILS: 'Fetching Recipe details...',
  FETCHING_REPLIES: 'Fetching Replies...',
  FETCHING_SHIPPING_METHODS: 'Fetching Shipping Methods...',
  FETCHING_SHIPPINGS: 'Fetching Shipping...',
  FETCHING_SHIPPINGS_DETAILS: 'Fetching Shipping details...',
  FETCHING_STATES: 'Fetching States...',
  FETCHING_STORES: 'Fetching Customers...',
  FETCHING_STORES_DETAILS: 'Fetching Customer Details...',
  FETCHING_SUBCATEGORIES: 'Fetching Subcategories...',
  FETCHING_TAX: 'Fetching Taxes...',

  FILE_SIZE_MSG: 'File size exceeds 2 MB limit. Please choose a smaller file',
  FILTER: 'Filter',
  FIRST_NAME: 'First Name',
  FORGOT_PASSOWRD: 'Forgot Password?',
  FROM: 'From',

  GENERAL_PRODUCT_COST: 'General Product Cost',
  GENERATE: 'Generate',
  GETUSER_PROFILE: 'getUser profile...',
  GREATER_THAN_ZERO: 'Greater Than Zero',

  HIGH_PRIORITY: 'High Priority',

  INACTIVE: 'Inactive',
  INGREDIENT: 'Ingredient',
  INGREDIENT_IMAGE: 'Ingredient Label Image',
  INGREDIENT_NAME: 'Ingredient Name',
  INGREDIENT_QUANTITY: 'Ingredient Quantity',
  INGREDIENTS: 'Ingredients',

  INVOICE: 'Invoice',
  INVOICE__ID: 'InvoiceID',
  INVOICE_DATE: 'Invoiced Date :',
  INVOICE_DETAILS: 'Invoice Details',
  INVOICE_FILTER: 'Invoice Filter',
  INVOICE_ID: 'Invoice ID',
  INVOICE_QUANTITY: 'Invoice Quantity',
  INVOICED_DATE: 'Invoiced Date',
  INVOICED_VALUE: 'Invoiced Value',
  INVOICES: 'Invoices',

  IS_NOT_SAME: 'Is not the same',
  IS_REQUIRED: 'is Required',

  KEEP_AS_NEW: 'Keep as new',

  LANGUAGE: 'Language',
  LANGUAGES: 'Languages',
  LAST_ACCESS: 'Last Access',
  LAST_NAME: 'Last Name',
  LAST_ORDER_DATE: 'Last Order Date',
  LEGAL_NAME: 'Legal Name',
  LOGGED_IN_SUCCESSFULLY: 'Logged in successfully',
  LOGOUT: 'Logout',

  MEASURE_PER_UNITS: 'Measure per Unit',
  MEASURE_TYPE: 'Measure Type',
  MESSAGES: 'Messages',
  MESSAGE_COMPOSE: 'Message Compose',
  MESSAGE_FILTERS: 'Message Filters',
  MESSAGES_THREAD: 'Messages Thread',
  METHOD: 'Method',
  METHODS: 'Methods',
  MOBILE: 'Mobile',

  MODIFYING_LANGUAGE: 'Modifying Language...',
  NEW_STORE_ADDED_SUCCESSFULLY: 'New Customer added successfully',
  MODIFYING_PRODUCTS_DETAILS: 'Modifying Product details...',
  MINIMUM_DELIVERY_TIMEFRAME: 'Minimum Delivery Timeframe',
  MESSAGE_IS_REQUIRED: 'Message is Required',
  MODIFY_STORE_DETAILS: 'Modifying Customer Details…',
  NOTE_CREATED_SUCCESSFULLY: 'Note created successfully',
  MODIFYING_PROFILE: 'Modifying profile...',

  NAME: 'Name',
  NEW: 'New',
  NEW_MESSAGE: 'New Message',
  NEW_ORDER_SUMMARY: 'New Order Summary',
  NEW_PASSWORD: 'New Password',
  NO: 'No',
  NO_DATA_FOUND: 'No data found',
  NO_STORE_NOTES_AVAILABLE: 'No Customer Notes available',
  NO_SUBORDERS_PRESENT: 'No suborders present',
  NO_YES: 'YES / NO',
  NOT_APPLICABLE: 'Not Applicable',
  NOTE: 'Note',
  NORMAL: 'Normal',
  NUTRITION_IMAGE: 'Nutrition Label Image',

  OK: 'Ok',
  ORDER__DATE: 'Order Date',
  ORDER_BY: 'Order By',
  ORDER_DATE: 'Order Date',
  ORDER_DETAILS: 'Order Details',
  ORDER_FILTER: 'Order Filter',
  ORDER_ID: 'Order ID',
  ORDER_INFO: 'Order Info',
  ORDER_PROCESSING: 'Order Processing',
  ORDER_STATUS: 'Order Status',
  ORDERED: 'Ordered',
  ORDERS: 'Orders',
  OTHER_DETAILS: 'Other Details',

  PACKED: 'Packed',
  PACKED_AND_SHIPPING: 'Packed and Shipping',
  PARENT_ADDRESS: 'Parent Address',
  PARENT_CITY: 'Parent City',
  PARENT_COUNTRY: 'Parent Country',
  PARENT_EMAIL_ID: 'Parent Email',
  PARENT_POSTAL_CODE: 'Parent Zip/Postal Code',
  PARENT_STATE: 'Parent State/Province',
  PARENT_WORK: 'Parent Work',
  PARENT_WORK_NUMBER: 'Parent Work Number',

  PASSWORD: 'Password',
  PASSWORD_UPDATED_SUCCESSFULLY_LOGGING_OUT:
    'Password updated successfully, logging out...',
  PAYMENT: 'Payment',
  PAYMENT_DUE_DATE: 'Payment Due Date',
  PAYMENT_TERMS: 'Payment Terms',

  PENDING_ORDER: 'Pending Order',
  PHONE: 'Phone',
  PLEASE_ENTER_DESCRIPTION: 'Please enter Description',
  PLEASE_ENTER_SUBJECT: 'Please enter Subject',
  PLEASE_ENTER_VALID: 'Please enter valid ',
  PLEASE_ENTER_VALID_CREDINALS: 'Please enter valid credentials',
  PLEASE_SELECT_NAME: 'Please select Name',
  PLEASE_TYPE_ASSIGN: 'Please Type Assign',
  PLEASE_TYPE_UNASSIGN: 'Please Type Unassign',
  PLEASE_SELECT_ORDER_TO_CANCEL: 'Please select order to delete',
  PLEASE_UPLOAD: 'Please upload an image below 2 MB in size.',

  POSTAL_CODE: 'Zip/Postal Code',
  PREFERRED_SHIPPING_METHOD: 'Preferred Shipping Method',
  PREVIEW_CONSOLIDATED_RECIPE_BUILDER: 'Preview Consolidated Recipe Builder',
  PRICE: 'Price',
  PRINT: 'Print',
  PRIORITY: 'Priority',

  PROCEDDING_ORDER: 'Procedding Order',
  PROCEED: 'Proceed',
  PROCESS: 'Process',
  PROCESS_ALL: 'Process all',
  PROCESS_WITH_BACK_ORDER: 'Process with back order',

  PRODUCT: 'Product',
  PRODUCT_DETAILS: 'Product Details',
  PRODUCT_FILTER: 'Product Filter',
  PRODUCT_ID: 'Product ID',
  PRODUCT_IMAGE: 'Product Image',
  PRODUCT_NAME: 'Product Name',
  PRODUCT_QUANTITY: 'Product Quantity',
  PRODUCT_STATUS: 'Product Status',
  PRODUCT_TYPE: 'Product Type',
  PRODUCTS: 'Products',
  PRODUCTS_OFFERED: 'Products Offered',
  PRODUCTION_DATE: 'Production Date',
  PRODUCTION_ID: 'Production ID',
  PRODUCTION_PLAN: 'Production Plan',
  PRODUCTION_PLAN_PREVIEW: 'Production Plan Preview',
  PRODUCTION_REPORT_HISTORY: 'Production Report History',
  PRODUCTION_REPORT: 'Production Report',
  PRODUCTION_REPORT_DETAILS: 'Production Report Details',
  PRODUCTION_REPORTS: 'Production Reports',

  PROFILE: 'Profile',
  PROFILE_SETTINGS: 'Profile and Settings',
  PROVINCE: 'Province',

  QR_CODE: 'QR Code',
  QUANTITY: 'Quantity',
  QUANTITY_INVOICED: 'Quantity Invoiced',
  QUANTITY_ORDERED: 'Quantity ordered',
  QUANTITY_PER_UNIT: 'Quantity per unit',
  QUANTITY_SHIPPED: 'Quantity Shipped',
  QUANTITY_SENT: 'Quantity Sent',

  RATE1: 'Rate 1',
  RATE2: 'Rate 2',
  RATE_1: 'Rate 1',
  RATE_2: 'Rate 2',

  REACTIVATE: 'Reactivate',
  REACTIVATE_CATEGORY: 'Reactivate Category',
  REACTIVATE_CATEGORY_MESSAGE:
    'Are you sure you want to reactivate this Category?',
  REACTIVATE_STORE: 'Reactivate Customer',
  REACTIVATE_STORE_MESSAGE:
    'Are you sure you want to reactivate this customer?',
  REACTIVATE_SUB_CATEGORY: 'Reactivate Subcategory',
  REACTIVATE_SUB_CATEGORY_MESSAGE:
    'Are you sure you want to reactivate this Subcategory?',
  REACTIVATING_PRODUCT: 'Reactivating Product...',
  REACTIVATING_STORE: 'Reactivating Customer...',
  READ: 'Read',
  REC_SENT: 'Rec-sent',
  RECIPE: 'Recipe',
  RECIPE_BUILDER: 'Recipe Builder',
  RECIPE_BUILDER_BY_SINGLE_PRODUCT: 'Recipe Builder by Single Product',
  RECIPE_BUILDER_INGREDIENTS: 'Recipe Builder Ingredients',
  RECIPE_BUILDER_REPORT: 'Recipe Builder Report',
  RECIPE_BUILDER_TYPE: 'Recipe Builder Type',
  RECIPE_BUILDER_NOT_AVAILABLE_FOR_PURCHASED_PRODUCTS:
    'Recipe Builder not available for Purchased products',

  REMEMBER_ME: 'Remember me',
  REPLY: 'Reply',
  REPORTS: 'Reports',
  REQUESTED_DATE: 'Requested Date',
  REQUESTED_DELIVERY_DATE: 'Requested Delivery Date',
  RETAIL_PRICE: 'Retail Price',
  ROWS_PER_PAGE: 'Rows per page',

  SAVE: 'Save',
  SAVE_CHANGES: 'Save Changes',
  SAVE_NOTE: 'Save Note',
  SEARCH: 'Search',

  SELECT: 'Select ',
  SELECT_BACKORDER: 'Select Backorder',
  SELECT_BILL_TO: 'Select Bill To',
  SELECT_CATEGORY: 'Select Category',
  SELECT_DATE: 'Select Date',
  SELECT_FROM: 'Select From',
  SELECT_INGREDIENT: 'Select Ingredient',
  SELECT_LANGUAGE: 'Select Language',
  SELECT_ORDERS_TO_CANCEL: 'Select Orders to Cancel',
  SELECT_RECIPE_BUILDER: 'Select Recipe Builder',
  SELECT_SHIPPING_CHARGE: 'Select Shipping Charge',
  SELECT_SHIPPING_FORM: 'Select Shipping Form',
  SELECT_TO: 'Select To',

  SEND: 'Send',
  SENT: 'Sent',
  SEND_RECEIVE: 'Send/receive',
  SENDING_MESSAGES: 'Sending Messages...',
  SENDING_REPLIES: 'Sending Replies...',

  SET_AS_HIGH_PRIORITY: 'Set as High Priority',
  SIGN_IN: 'Sign In',
  SIGN_IN_PORTAL: 'Order-EZ Supplier Sign-In Portal',

  SHIP_TO: 'Ship To',
  SHIP_VIA: 'Ship Via',
  SHIPP_DATE: 'Shipped Date',
  SHIPPED_DATE: 'Shipped Date',
  SHIPPED_ORDER_DETAILS: 'Shipped Order Details',
  SHIPPED_QUANTITY: 'Shipped Quantity',
  SHIPPED_QUANTITY_REQUIRED:
    'Shipped Quantity is required for all non-cancelled items',
  SHIPPED_VIA: 'Shipped Via',
  SHIPPING: 'Shipping',
  SHIPPING_CALCULATION: 'Shipping Calculation',
  SHIPPING_CHARGE: 'Shipping Charge',
  SHIPPING_CHARGES: 'Shipping Charges',
  SHIPPING_DATE: 'Shipping Date',
  SHIPPING_DETAILS: 'Shipping Details',
  SHIPPING_FILTER: 'Shipping Filter',
  SHIPPING_FORM: 'Shipping Form',
  SHIPPING_ID: 'Shipping ID',
  SHIPPING_MEMO_INVOICE: 'Shipping Memo and Invoice',
  SHIPPING_MEMO: 'Shipping Memo',
  SHIPPING_MEMOS: 'Shipping Memos',
  SHIPPING_METHOD: 'Shipping Method',
  SHIPPING_QUANTITY: 'Shipping Quantity',
  SHIPPING_RATE: 'Shipping Rate',

  SKU_ID: 'SKU ID',
  SKU_IMAGE: 'SKU Image',
  SKU_NUMBER: 'SKU Number',
  STATE: 'State',
  STATUS: 'Status',

  STORE: 'Customer',
  STORE_ADDRESS: 'Customer Address',
  STORE_CITY: 'Customer City',
  STORE_CONTACT: 'Customer Contact',
  STORE_COST: 'Customer cost',
  STORE_COUNTRY: 'Customer Country',
  STORE_DETAILS: 'Customer Details',
  STORE_FILTER: 'Customer Filter',
  STORE_ID: 'Customer ID',
  STORE_LOGO: 'Customer Logo',
  STORE_MOBILE: 'Customer Mobile',
  STORE_MODIFIED_SUCCESSFULLY: 'Customer modified successfully',
  STORE_NAME: 'Customer Name',
  STORE_NOTE: 'Customer Note',
  STORE_NOTES: 'Customer Notes',
  STORE_NUMBER: 'Customer Number',
  STORE_PRODUCT_FILTER: 'Customer Product Filter',
  STORE_PRODUCTS: 'Customer Products',
  STORE_PO: 'Customer PO no.',
  STORE_PO_NUMBER: 'Customer PO Number',
  STORE_POSTAL_CODE: 'Customer Zip/Postal Code',
  STORE_PROVINCE: 'Customer Province',
  STORE_STATE: 'Customer State/Province',
  STORE_TAX1: 'Customer Tax1',
  STORE_TAX1_RATE: 'Customer Tax1 Rate',
  STORE_TAX2: 'Customer Tax2',
  STORE_TAX2_RATE: 'Customer Tax2 Rate',
  STORES: 'Customers',
  STORE_STATE_PROVINCE: 'Customer State/Province',
  STATE_PROVINCE: 'State/Province',
  PARENT_PROVINCE: 'Parent State/Province',
  SUB_CATEGORY: 'Subcategory',
  SUB_CATEGORY_NOT_FOUND: 'Subcategories not found',
  SUB_TOTAL: 'Subtotal',
  SUBCATEGORY: 'Subcategory',
  SUBCATEGORY_NAME: 'Subcategory Name',
  SUBJECT: 'Subject',
  SUBORDER_ID: 'Suborder ID',

  SUPPLIER_NAME: 'Supplier Name',
  SUPPLIER_DETAILS: 'Supplier Details',
  SUPPLIER_NOTES: 'Supplier Notes',
  SUPPLIER_PROFILE: 'Supplier Profile',
  SUPPLIERS: 'Suppliers',

  TAG: 'Tag',
  TAX_DESCRIPTION: 'Tax Description',
  TAX_NUMBER1: 'Tax Number 1',
  TAX_NUMBER2: 'Tax Number 2',
  TAX_RATE: 'Tax Rate',
  TAXES: 'Taxes',
  TERMS: 'Terms',

  TO: 'To',
  TO_ALL_STORES: 'To All Customers',
  TO_BE_CONFIRMED: 'to be confirmed',
  TOTAL: 'Total',
  TOTAL_INVOICE: ' Total Invoice : ',
  TOTAL_ORDERS: 'Total Orders',
  TOTAL_ORDER_VALUE: 'Total Order Value',
  TOTAL_PRICE: 'Total Price',
  TOTAL_REQUIRED: 'Total Required',
  TYPE: 'Type',
  TYPE_DEACTIVATE_HERE: 'Type DEACTIVATE here',
  TYPE_REACTIVATE_HERE: 'Type REACTIVATE here',

  UNASSIGN: 'Unassign',
  UNIT: 'Unit',
  UNIT_OF_MEASURE: 'Units of Measure',
  UNIT_PRICE: 'Unit Price',

  UPDATE: 'Update',
  UPDATE_CATEGORY_DETAILS: 'Updating category details...',
  UPDATE_INVOICE_DETAILS: 'Update Invoice Details',
  UPDATE_PRODUCT: 'Update Product',
  //UPDATE_PRODUCT: 'Assign Product to all the Stores',
  UPDATE_PRODUCT_MESSAGE:
    'Are you sure you want to update this Product Status?',
  //UPDATE_PRODUCT_MESSAGE: 'Are you sure you want to Assign selected Product to all the Stores?',
  UPDATE_SHIPPING_DETAILS: 'Update Shipping Details',
  UPDATING_ORDER_STATUS: 'Updating Order Status...',
  UPDATING_PRODUCT: 'Updating Product...',
  UPDATING_SUBCATEGORIES_DETAILS: 'Updating Subcategory Details...',

  UPLOAD: 'Upload',
  UPLOADING_PRODUCT_IMAGE: 'Uploading Product Image',
  UPLOADING_INGREDIENT_LABEL_IMAGE: 'Uploading Ingredient Label Image...',
  UPLOADING_NUTRITION_LABEL_IMAGE: 'Uploading Nutrition Label Image...',
  UPLOADING_PROFILE_IMAGE: 'Uploading Profile Image...',
  UPLOADING_QR_CODE_IMAGE: 'Uploading QR Code Image...',
  UPLOADING_SKU_IMAGE: 'Uploading SKU Image...',
  UPLOADING_LOGO: 'Uploading Logo...',
  URGENT: 'Urgent',
  USERNAME: 'Username',

  VARIANCE: 'Variance',
  VERSION: 'Version',
  VIEW_ALL: 'view all',
  VIEW_CONSOLIDATED_RECIPE_BUILDER: 'View Consolidated Recipe Builder',
  VIEW_STORE_NOTES: 'View Customer Notes',
  VIEW_SUPPLIER_NOTES: 'View Supplier Notes',

  WORK: 'Work',
  WORK_PHONE_NUMBER: 'Work Phone Number',
  YES: 'Yes',
  YOU_MUST_COMPLETE_ALL_REQUIRED_FEILDS_OR_CHANGES_WILL_BE_LOST:
    'You must complete all required fields or changes will be lost',
  BACK: 'Back',
  CONTINUE: 'Continue',
  VIEW_REPLY: 'View / Reply',
  NOTE_YOU_CAN_ENTER_UP_TO_500_CHARACTERS:
    'Note: You can enter up to 500 characters.',
  NO_PRODUCTS_SELECTED_FOR_STATUS_UPDATE:
    'No products selected for status update.',
  NO_PRODUCTS_SELECTED_ASSIGNMENT: 'No products selected for unassignment.',
  NO_PRODUCTS_SELECTED_UNASSIGNMENT: 'No products selected for unassignment.',

  SELECT_PRODUCT_NAME: 'Select product name',
  ENTER_PRODUCT_ID: 'Enter product ID',
  SELECT_PRODUCT_TYPE: 'Select product type',
  SELECT_SUB_CATEGORY: 'Select sub category',
  SELECT_RECIPE_BUILDER_TYPE: 'Select recipe builder type',
  ENTER_RETAIL_PRICE: 'Enter retail price',
  SELECT_MINIMUM_DELIVERY_TIMEFRAME: 'Select minimum delivery timeframe',
  SELECT_STATUS: 'Select status',
  ENTER_GENERAL_PRODUCT_COST: 'Enter general product cost',
  ENTER_DESCRIPTION: 'Enter description',
  ENTER_SKU_NUMBER: 'Enter Sku number',
  ENTER_CATEGORY_NAME: 'Enter category name',
  PLEASE_ENTER_PRODUCT_ID: 'Please enter valid product Id',
  ENTER_SUBCATEGORY_NAME: 'Enter SubCategory Name',
  SELECT_DIFFERENT_LEGAL_NAME: 'Select diffrent legal name',
  SELECT_COUNTRY: 'Select country',
  SELECT_STATE: 'Select State/Province',
  ENTER_DISCOUNT_PER: 'Enter discount % of retail price',
  ENTER_STORE_TAX1: 'Enter Customer Tax Name (1)',
  ENTER_STORE_TAX2: 'Enter Customer Tax Name (2)',
  ENTER_COMPANY_NAME: 'Enter company name',
  ENTER_CITY: 'Enter city',
  ENTER_COMPANY_ADDRESS: 'Enter Company Address',
  ENTER_POSTAL_CODE: 'Enter Zip/Postal Code',
  SELECT_METHOD: 'Select method',
  SELECT_TERMS: 'Select terms',
  SELECT_SHIP_TO: 'Select ship to',
  SELECT_SHIPPING_METHOD: 'Select shipping method',
  ENTER_SHIPPING_CHARGES: 'Enter shipping charges',
  SELECT_SHIPPING_CALCULATION: 'Select shipping calculations',
  SELECT_SHIPPING_CHARGES: 'Select shipping charges',
  ENTER_NAME: 'Enter name',
  PLEASE_ENTER_VALID_STORE_POSTAL_CODE:
    'Please enter valid Customer Zip/Postal Code',
  PLEASE_ENTER_VALID_DISCOUNT_RETAIL_PRICE:
    'Please enter valid discount % of retail price',
  PLEASE_ENTER_VALID_EMAIL: 'Please enter valid Email ID',
  PLEASE_ENTER_VALID_WORK_NUMBER: 'Please enter valid work number',
  PLEASE_ENTER_VALID_MOBILE: 'Please enter valid mobile',
  PLEASE_ENTER_VALID_PARENT_POSTAL_CODE:
    'Please enter valid parent Zip/Postal Code',
  PLEASE_ENTER_VALID_PARENT_EMAIL: 'Please enter valid parent email ID',
  PLEASE_ENTER_VALID_PARENT_WORK_NUMBER:
    'Please enter valid parent work number',
  ENTER_SUBJECT: 'Enter Subject',
  SELECT_CITY: 'Select city',
  SELECT_POSTAL_CODE: 'Select Zip/Postal Code',
  SELECT_PRIORITY: 'Select priority',
  SELECT_PRODUCT: 'Select product',
  INGREDIENTS_ALLREADY_ADDED: 'This ingredient is already added',
  SELECT_PRODUCTION_REPORT: 'Select Production report',
  PRODUCTION_REPORT_IS_REQUIRED: 'Production report is required',
  GETTING_REPORT: 'Getting Report',

  TAX_DESCRIPTION_IS_REQUIRED: 'Tax description is required',
  TAX_RATE_IS_REQUIRED: 'Tax rate is required',
  INVALID_IMG_DIMENTIONS:
    'Invalid image dimensions. Please use 1280x720 or 1920x1080',
  NEW_CONFIRM_PASSWORD_IS_NOT_SAME:
    'Passwords do not match. Please check and try again.',
  PRICE_MUST_BE_GREATER_THAN_ZERO: 'Price must be greater than zero',
  QUANTITY_MUST_BE_GREATER_THAN_ZERO: 'Quantity must be greater than zero',
  REQUESTED_DELIVERY_DATE_IS_REQUIRED: 'Requested delivery date is required',
  REQUESTED_DELIVERY_DATE_MUST_IN_FUTURE:
    'FRequested delivery date must be in the future',
  THIS_PRODUCT_IS_ALREADY_ADDED: 'This product is already added',
  QUANTITY_MUST_GREATER_THAN_ZERO: 'Quantity must be greater than 0',
  NO_DATA_FOUND_SUB_FOR_CATEGORY: 'No data found for Sub Category',
  SELECT_ALL_ROWS_ASSIGNMENT: 'Selected all rows products for status update',
  DUE_DATE_IS_REQUIRED: 'Due date is required',
  INGREDIENT_NAME_REQUIRED: 'Ingredient name is required',
  INGREDIENTS_IS_REQUIRED: 'Ingredient is required',
  PRODUCT_NAME_CANNOT_SAME: 'Product name cannot be the same',
  SHIPPING_METHOD_IS_REQUIRED: 'Shipping method is required',
  TAX_REQUIRED: 'Tax is required',
  TAX_RATE_REQUIRED: 'Tax rate is required',
  NO_PRODUCTS_ASSIGNMENT: 'No products selected for assignment.',
  FETCHING_INVOICE_DETAILS: 'Fetching Invoice Details...',
  FETCHING_PRODUCTION_REPORT: 'Fetching Production Report...',
  CANCELLING_PRODUCTION: 'Cancellling Production...',
  NEW_PRODUCT_ADDED: 'New Product added successfully',
  PROCEED_MESSAGE: 'Are you sure you want to proceed',
  CONFIRMATION: 'Confirmation',
  DELETE_ITEM_MESSAGE: 'Are you sure you want to delete this item?',
  CANCEL_CONFIRMATION: 'Cancel Confirmation',
  ORDER_CANCEL_CONFIRM_MESSAGE: 'Are you sure you want to cancel?',
  ASSIGN_PRODUCT_MESSAGE: 'Are you sure you want to assign this Product?',
  UNASSIGN_PRODUCT: 'Unassign Product',
  UNASSIGN_PRODUCT_MESSAGE: 'Are you sure you want to unassign this Product?',
  ENTER_TAX_DESCRIPTION: 'Enter tax description',
  ENTER_TAX_RATE: 'Enter tax rate',
  SPLIT: 'Split',
  PLEASE_ENTER_SUPPLIER_TAX1: 'Please enter valid supplier tax 1',
  PLEASE_ENTER_SUPPLIER_TAX2: 'Please enter valid supplier tax 2',
  ENTER_SUPPLIER_TAX1: 'Enter Supplier Tax1',
  ENTER_SUPPLIER_TAX2: 'Enter Supplier Tax2',
  SUPPLIER_TAX1: 'Supplier Tax 1',
  SUPPLIER_TAX2: 'Supplier Tax 2',

  ZERO_QUANTITY_NOT_ALLOWED: 'Zero quantity is not allowed',
  CONFIRMED_QUANTITY: 'Confirmed Quantity',
  ZERO_PRICE_NOT_ALLOWED: 'Zero price is not allowed',
  ENTER_SHIPPING_METHOD: 'Enter Shipping Method',
  FETCHING_SHIP_TO_DETAILS: 'Fetching ShipTo Details',
  UPDATED_SHIPPING_DETAILS_SUCCESSFULLY:
    'Updated shipping details successfully',
  INVALID_IMAGE_DIMENTIONS: 'Invalid image dimentions',
  DEFAULT_SHIP_TO: 'Default ShipTo is Store',
  IMAGE_UPLOAD_MESSAGE:
    'Accepted Image Formats: JPG, PNG, JPEG | Max File Size: 2MB | Preferred Resolution: 1280x720 pixels',
  DOWNLOADING_PRODUCTION_PLAN: 'Downloading Production Plan',
  VIEW: 'View',
  DOWNLOADING_CONSOLIDATED_RECIPE_BUILDER: 'Downloading Production Plan',
  DOWNLOADING_RECIPE_BUILDER_SINGLE:
    'Downloading  Recipe Builder for a single product',
  DOWNLOADING_SHIPING_DETAILS: 'Downloading Shipping Details',
  DOWNLOADING_INVOICE_DETAILS: 'Downloading Invoice Details',

  STORE_EMAIL: 'Customer Email',
  PLEASE_TYPE_DEACTIVATE: 'Please Type DEACTIVATE',
  PLEASE_TYPE_REACTIVATE: 'Please Type REACTIVATE',

  VIEW_ALL_ORDERS: 'View all orders due on selected date',
  UNASSIGN_FROM_ALL_STORES: 'Unassign from all Customers',
  ADD_TO_ALL_STORES: 'Add to all Customers',

  USA: 'USA',
  CANADA: 'Canada',

  // Canada State--
  ONTARIO: 'Ontario',
  QUEBEC: 'Quebec',
  NOVA_SCOTIA: 'Nova Scotia',
  NEW_BRUNSWICK: 'New Brunswick',
  MANITOBA: 'Manitoba',
  BRITISH_COLUMBIA: 'British Columbia',
  PRINCE_EDWARD_ISLAND: 'Prince Edward Island',
  SASKATCHEWAN: 'Saskatchewan',
  ALBERTA: 'Alberta',
  NEWFOUNDLAND_AND_LABRADOR: 'Newfoundland and Labrador',

  // USA State--
  ALABAMA: 'Alabama',
  ALASKA: 'Alaska',
  ARIZONA: 'Arizona',
  ARKANSAS: 'Arkansas',
  CALIFORNIA: 'California',
  COLORADO: 'Colorado',
  CONNECTICUT: 'Connecticut',
  DELAWARE: 'Delaware',
  DISTRICT_OF_COLUMBIA: 'District of Columbia',
  FLORIDA: 'Florida',
  GEORGIA: 'Georgia',
  HAWAII: 'Hawaii',
  IDAHO: 'Idaho',
  ILLINOIS: 'Illinois',
  INDIANA: 'Indiana',
  IOWA: 'Iowa',
  KANSAS: 'Kansas',
  KENTUCKY: 'Kentucky',
  LOUISIANA: 'Louisiana',
  MAINE: 'Maine',
  MARYLAND: 'Maryland',
  MASSACHUSETTS: 'Massachusetts',
  MICHIGAN: 'Michigan',
  MINNESOTA: 'Minnesota',
  MISSISSIPPI: 'Mississippi',
  MISSOURI: 'Missouri',
  MONTANA: 'Montana',
  NEBRASKA: 'Nebraska',
  NEVADA: 'Nevada',
  NEW_HAMPSHIRE: 'New Hampshire',
  NEW_JERSEY: 'New Jersey',
  NEW_MEXICO: 'New Mexico',
  NEW_YORK: 'New York',
  NORTH_CAROLINA: 'North Carolina',
  NORTH_DAKOTA: 'North Dakota',
  OHIO: 'Ohio',
  OKLAHOMA: 'Oklahoma',
  OREGON: 'Oregon',
  PENNSYLVANIA: 'Pennsylvania',
  RHODE_ISLAND: 'Rhode Island',
  SOUTH_CAROLINA: 'South Carolina',
  SOUTH_DAKOTA: 'South Dakota',
  TENNESSEE: 'Tennessee',
  TEXAS: 'Texas',
  UTAH: 'Utah',
  VERMONT: 'Vermont',
  VIRGINIA: 'Virginia',
  WASHINGTON: 'Washington',
  WEST_VIRGINIA: 'West Virginia',
  WISCONSIN: 'Wisconsin',
  WYOMING: 'Wyoming',

  B2B: 'B2B',
  B2C: 'B2C (Coming Soon)',
  PICKUP: 'Pickup',
  OTHER: 'Other',
  ALL: 'All',
  UNAVAILABLE: 'Temp. Unavailable',
  PURCHASED: 'Purchased',
  MANUFACTURED: 'Manufactured',
  PROCESSED: 'Processed',
  INPRODUCTION: 'InProduction',
  SHIPPED: 'Shipped',
  INVOICED: 'Invoiced',
  COMPLETE: 'Complete',
  CANCELLED: 'Cancelled',
  BY_STORE: 'By Customer',
  BY_PRODUCT: 'By product',

  // Payment Methods
  CREDIT_CARD: 'Credit Card',
  INTERAC: 'Interac',
  LINE: 'Line',
  TBA: 'TBA',
  CHAINSTORE: 'Chain Store',
  ASSIGNED: 'Assigned',
  UNASSIGNED: 'Unassigned',
  ENTER_PHONE_NUMBER: 'Enter phone number',
  PERCENTAGE: 'Percentage',
  AMOUNT: 'Amount',
  ENTER_NOTE: 'Enter Note',

  ENTER_UNIT_OF_MEASURE: 'Enter Unit of Measure',
  ENTER_QUANTITY_PER_UNIT: 'Enter Quantity per Unit',
  ENTER_COST_PRICE: 'Enter Cost Price',
  ENTER_INGREDIENT_NAME: 'Enter Ingredient Name',
  MESSAGE_TO: 'Message To',
  ADD_NEW_SHIPPING_METHOD: 'Add new shipping method',
  ADD_NEW_INGREDIENT: 'Add new Ingredient',
  CATEGORY_UPDATE_SUCCESS: 'Category updated successfully',
  CATEGORY_UPDATE_FAIL: 'Failed to update Category.',
  CATEGORY_ADDED_SUCCESS: 'Category added successfully',
  CATEGORY_ADDITION_FAILED: 'Failed to add Category.',
  INGREDIENT_CREATED_SUCCESS: 'Ingredient created successfully',
  INGREDIENT_CREATION_FAILED: 'Failed to create Ingredient',
  INVOICE_CREATED_SUCCESS: 'Invoice created successfully',
  INVOICE_CREATION_FAILED: 'Failed to create Invoice',
  ORDER_STATUS_CHANGED_SUCCESS: 'Order Status changed successfully',
  ORDER_STATUS_CHANGE_FAILED: 'Failed to change Order Status',
  ORDER_SPLIT_SUCCESS: 'Order split successfully',
  ORDER_SPLIT_FAILED: 'Failed to split Order',
  CONFIRM_PRODUCTION_SAVED_SUCCESS: 'Confirm Production saved successfully',
  CONFIRM_PRODUCTION_SAVE_FAILED: 'Failed to save Confirm Production',
  ORDER_SHIPPED_SUCCESS: 'Order shipped successfully',
  ORDER_SHIPPED_FAILED: 'Failed to ship Order',
  ORDER_CANCELLED_SUCCESS: 'Order cancelled successfully',
  ORDER_CANCELLED_FAILED: 'Failed to cancel Order',
  PRODUCTS_ASSIGNED_SUCCESS: 'Products assigned successfully',
  PRODUCTS_ASSIGN_FAILED: 'Failed to assign Products',
  PRODUCT_DEACTIVATED_SUCCESS: 'Product deactivated successfully',
  PRODUCT_DEACTIVATION_FAILED: 'Failed to deactivate Product',
  PRODUCT_REACTIVATED_SUCCESS: 'Product reactivated successfully',
  PRODUCT_REACTIVATION_FAILED: 'Failed to reactivate Product',
  PRODUCT_UPDATED_SUCCESS: 'Product updated successfully',
  PRODUCT_UPDATE_FAILED: 'Failed to update Product',
  PROFILE_UPLOADED_SUCCESS: 'Profile uploaded successfully',
  PROFILE_UPLOAD_FAILED: 'Failed to upload Profile',
  TAX_ADDED_SUCCESS: 'Tax added successfully',
  TAX_ADD_FAILED: 'Failed to add Tax',
  SUBCATEGORY_ADDED_SUCCESS: 'Subcategory added successfully',
  SUBCATEGORY_ADD_FAILED: 'Failed to add Subcategory',
  SUBCATEGORY_UPDATED_SUCCESS: 'Subcategory updated successfully',
  SUBCATEGORY_UPDATE_FAILED: 'Failed to update Subcategory',

  BY_WEIGHT: 'By Weight ',
  BY_PERCENTAGE: 'By Percentage',
  ALL_ORDERS_DUE_ON: 'All Orders Due On',
  ORDERS_DUE_ON: 'Orders due on',
  ORDERS_DUE_TO: 'Orders due to',
  ORDERS_DUE_FROM: 'Orders due from',
  SHIPPING_CHARGE_PERCENTAGE: 'Shipping charge Percentage',
  SHIPPING_CHARGE_AMOUNT: 'Shipping charge Amount',
  POWERED_BY_ORDER_EZ: 'Powered by Order-EZ.com',
  SHIPPED_ORDER_STATUS: 'Shipped Order Status',
  PACKED_ORDER_STATUS: 'Packed Order Status',
  FETCHING_DATA: 'Fetching Data',
  ADDING_NEW_TAX: 'Adding New Tax',
};
